import moment from 'moment-timezone';

const formatDate = {
    methods: {
        $date(date){
            return moment.tz(date, "America/Sao_Paulo").format('DD/MM/YY');
        },

        $datetime (date) {
            return moment.tz(date, "America/Sao_Paulo").format('DD/MM/YY H:mm');
        },

        $dateDefault(date){
            return moment(date).format('DD/MM/YY');
        }
    }
}

export default formatDate